export default "__VITE_ASSET__CdIowuRi__"